export default __webpack_public_path__ + "static/media/ANU.9d9f5169.jpeg";